<template>
  <b-table
    :data="isEmpty ? [] : data"
    :bordered="isBordered"
    :narrowed="isNarrowed"
    :hoverable="isHoverable"
    :loading="isLoading"
    focusable
    striped
    :mobile-cards="hasMobileCards"
    :selected.sync="selected"
    pagination-size="is-small"
  >
    <b-table-column field="acoes" label="Ações" header-class="custom-header" centered>
      <b-dropdown aria-role="list" title="Ações">
        <h1 slot="trigger" class="row-actions-circles">
          <div class="circle" />
          <div class="circle" />
          <div class="circle" />
        </h1>

        <b-dropdown-item aria-role="listitem">
          <div class="menu-row-option" @click="showmodal">
            <feather class="menu-row-icon archive" type="edit" size="16" />
            <h1>Editar</h1>
          </div>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem">
          <div
            class="menu-row-option"
            @click="$router.push(`/cadastro/fpagamento/details/` + selected.id)"
          >
            <feather class="menu-row-icon check" type="check" size="16" />
            <h1>Ver Detalhes</h1>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </b-table-column>
    <b-table-column
      v-slot="props"
      field="id"
      label="ID"
      width="40"
      numeric
      header-class="custom-header"
    >
      <h1 :ref="'a' + props.row.id" class="table-title-cad">
        {{ props.row.id }}
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="descricao"
      label="Descrição"
      centered
      header-class="custom-header"
    >
      <h1 class="table-title-cad">
        {{ props.row.descricao }}
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="status"
      label="Status"
      centered
      header-class="custom-header"
    >
      <h1 class="table-title-cad tag-status">
        <tag :state="props.row.status" :data="props.row.status == 0 ? 'Inativo' : 'Ativo'" />
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="associado_id"
      label="Associado ID"
      centered
      header-class="custom-header"
    >
      <span class="table-title-cad">
        {{ props.row.associado_id }}
      </span>
    </b-table-column>

    <b-table-column v-slot="props" label="Integração ID" centered header-class="custom-header">
      <span class="table-title-cad">
        {{ props.row.integracao_id }}
      </span>
    </b-table-column>
    <b-table-column v-slot="props" label="Tipo" centered header-class="custom-header">
      <span class="table-title-cad">
        {{ props.row.tipo }}
      </span>
    </b-table-column>
  </b-table>
</template>

<script>
import 'vue-context/src/sass/vue-context.scss';
import tag from '../tags/situation';

export default {
	components: {
		tag,
	},
	props: {
		data: {
			type: Array,
			default: () => {},
		},
	},
	data() {
		return {
			isEmpty: false,
			isBordered: false,
			isNarrowed: false,
			isHoverable: false,
			isFocusable: false,
			isLoading: false,
			hasMobileCards: true,
			selected: {},
		};
	},
	watch: {
		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
	},
	methods: {
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		showmodal() {
			this.$emit('editaction', this.selected);
		},
		showContext(row, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context, row);
		},
	},
};
</script>

<style lang="scss" scoped>
.table-title-cad {
  color: #25213b;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* .tag-status {
    color: #FFF;
} */
.details-button {
  font-size: 12px;
}

.custom-header {
  font-size: $header-size;
}
.is-success {
  display: flex;
  align-items: center;
}

.menu-row-icon {
  color: #8b83ba;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 500;
}

.menu-row-box-bottom {
  padding-top: 10px;
}
.menu-row-box {
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f0f9;
}
.menu-row-option:first-child {
  margin-top: 5px;
}
.menu-row-option:hover {
  color: #25213b !important;
  border-radius: 5px;
}

.menu-row-option:hover .danger {
  color: #dc3545 !important;
}

.menu-row-option:hover .check {
  color: #007f00;
}

.menu-row-option:hover .archive {
  color: #f77f00;
}

.menu-row-option {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-right: 5px;
  padding: 10px;
  cursor: pointer;
}

//Actions
.disabled {
  cursor: not-allowed !important;
}
.dropdown-menu {
  font-size: 12px !important;
}
.circle {
  width: 4px;
  height: 4px;
  margin: 1px;
  border-radius: 50%;
  background-color: rgb(212, 212, 212);
  transition: ease-in-out 0.5s;
}
.row-actions-circles {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.row-actions-circles:hover {
  cursor: pointer;
}
.row-actions-circles:hover .circle {
  background-color: rgb(139, 139, 139);
}
</style>
